import React, { FC } from "react";
import { ContainerProps } from "./Container.types";
import styles from "./Container.module.scss";

const Container: FC<ContainerProps> = ({ children, ...rest }) => {
  return (
    <div
      {...rest}
      className={[styles.Container, rest.className].join(" ")}
      data-testid="Container"
    >
      {children}
    </div>
  );
};

export default Container;
